import styled from 'styled-components';

export const StyledBottomElement = styled.div`
   margin-top: 4px;
   width: 100%;
`;

StyledBottomElement.displayName = 'StyledBottomElement';

export const StyledVisitMedicalServiceInteractiveTable = styled.div`
   height: 100%;
   overflow: hidden;
   display: flex;
   flex-direction: column;
`;

StyledVisitMedicalServiceInteractiveTable.displayName = 'StyledVisitMedicalServiceInteractiveTable';
